import { render, staticRenderFns } from "./EntwurfCard.vue?vue&type=template&id=4fadb208&scoped=true&"
import script from "./EntwurfCard.vue?vue&type=script&lang=js&"
export * from "./EntwurfCard.vue?vue&type=script&lang=js&"
import style0 from "./EntwurfCard.vue?vue&type=style&index=0&id=4fadb208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fadb208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
